var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClinetSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 79,
    viewBox: "0 0 72 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1133 9.93832C36.1133 4.46051 40.5734 0 46.0512 0C51.529 0 55.9895 4.46051 55.9895 9.93832C55.9895 15.518 51.5629 22.2677 46.0512 22.2677C40.5394 22.2677 36.1133 15.518 36.1133 9.93832Z",
    fill: "#111827"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4121 38.3963C27.4121 29.8148 34.3995 22.8276 42.9806 22.8276H48.5772C57.1587 22.8276 64.1462 29.8149 64.1462 38.3963C64.1462 40.6009 62.3484 42.3985 60.1436 42.3985H31.4317C29.2099 42.3985 27.4121 40.6009 27.4121 38.3963Z",
    fill: "#111827"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.406577 66.0017C-0.193034 66.6763 -0.118082 67.6507 0.55648 68.2503L11.9491 78.5935C12.6236 79.1932 13.598 79.1182 14.1976 78.4436L19.6691 72.3726L5.95298 59.9307L0.406577 66.0017Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.41 51.0115C69.5106 49.8872 68.0866 49.3626 66.6625 49.6624L55.12 52.2107C55.12 52.5105 55.12 52.7354 55.045 53.0352C54.5953 56.1831 52.1219 58.6565 48.899 59.0313L48.1495 59.1062C43.9522 59.6309 39.755 59.7808 35.5577 59.5559L32.1099 59.406C31.1355 59.3311 30.3111 58.4317 30.386 57.3824C30.461 56.333 31.3604 55.5086 32.4097 55.5835L35.8575 55.7334C39.8299 55.9583 43.8773 55.8084 47.8497 55.3587L48.5992 55.2837C50.0233 55.1338 51.1476 54.0095 51.3724 52.5105C51.5223 51.6861 51.2975 50.7866 50.7728 50.1121C50.2481 49.4375 49.4986 48.9878 48.5992 48.9129L30.6858 46.6643C28.6622 46.4395 26.6385 46.8142 24.9146 47.8635L8.875 57.3824L23.3406 70.4239L38.3309 73.1971C40.9542 73.7217 43.6524 73.1221 45.901 71.6981L69.5856 56.408C70.485 55.8084 71.0846 54.909 71.2345 53.8596C71.3844 52.8853 71.0846 51.836 70.41 51.0115Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinetSvg);
export default __webpack_public_path__ + "static/media/clinet-svg.22a12b2b67cff635f795365c7772913d.svg";
export { ForwardRef as ReactComponent };